<template>
  <div class="delivery-container">
    <van-form>
      <van-field
        v-model="userName"
        label="联系人"
        placeholder="请填写联系人"
      />
      <van-field
        v-model="phone"
        type="phone"
        label="手机号"
        placeholder="请填写手机号"
      />
      <van-field
        v-model="address"
        label="地址"
        placeholder="点击选择收货地址"
        type="textarea"
        autosize
        use-button-slot
      >
        <van-button
          slot="button"
          size="small"
          @click="showPicker = true"
          icon="share"
        />
      </van-field>

    </van-form>
    <div class="bottom">
      <van-button
        round
        block
        @click="onSubmit()"
        size="small"
        type="primary"
        native-type="submit"
      >保存</van-button>
    </div>
    <van-popup
      v-model="showPicker"
      position="bottom"
    >
      <van-picker
        show-toolbar
        :columns="addressList"
        value-key="address"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>
    <van-toast id="van-toast" />

  </div>
</template>

<script>
import manageApi from '@/api/manageApi';

export default {
  inject: ['reload'],
  data () {
    return {
      addressList: [],
      id: '',
      userName: '',
      phone: '',
      address: '',
      showPicker: false,
    };
  },
  created () {
    this.initAddressList();
    sessionStorage.clear();
  },
  mounted () {
    setTimeout(() => {
      // Toast.success.clear();
    }, 1000)
  },
  methods: {
    initAddressList () {
      let organId = this.organInfo.organCode;
      manageApi
        .queryUserAddress(organId)
        .then(res => {
          const data = res.data;
          this.addressList = data;
        })
        .catch(() => { })
        .finally(() => { });
      let prescriptionId = this.$route.query.prescriptionId
      manageApi
        .queryDrugDelivery({
          prescriptionId: prescriptionId
        })
        .then(res => {
          const data = res.data;
          this.id = data.id
          this.userName = data.userName;
          this.phone = data.phone;
          this.address = data.address;
        })
        .catch(() => { })
        .finally(() => { });
    },
    onAdd () {
      const { addressList } = this;
      if (5 <= addressList.length) {
        this.$toast('最多只能添加5个地址');
        return;
      }
      this.$router.push({
        path: '/manage/address_manage'
      });
    },
    onSubmit () {
      console.log('submit');
      const { $router } = this;
      if (!/^(?:(?:\+|00)86)?1[3-9]\d{9}$/.test(this.phone)) {
        this.$toast('请输入正确的手机号码')
        return
      }
      let prescriptionId = this.$route.query.prescriptionId
      manageApi
        .saveDrugDelivery({
          prescriptionId: prescriptionId,
          userName: this.userName,
          phone: this.phone,
          address: this.address,
          id: this.id
        })
        .then(res => {
          console.log('res', res)
          if (res.data) {
            this.$toast('提交成功')
            // this.$toast.success({
            //   message: '成功的提示文案',
            // })
            const data = res.data;
            this.id = data.id
            this.$router.push({
              path: '/manage/prescription_list'
            });
          } else {
            this.$toast(res.message)
          }
        })
        .catch(() => { })
        .finally(() => { });
    },
    onConfirm (e) {
      console.log(e)
      let address = ''
      this.address = Object.assign(e.address, address)
      this.showPicker = false;
    },
    onAddressInput (e) {
      console.log(e)
    }
  },
  computed: {
    organInfo () {
      return this.$hdk.data(this.$setter.organInfo);
    },
  }
};
</script>

<style lang="less" scoped>
.delivery-container .content {
  font-size: 0.346666rem;
  color: #323233;
  padding-bottom: 1.333333rem;
}

.delivery-container .content ul {
  background-color: white;
  margin: 0.4rem;
  padding: 0.266666rem 1.5rem 0.266666rem 0.4rem;
  border-radius: 0.2rem;
  position: relative;
}
.delivery-container .content li {
  line-height: 0.766666rem;
  word-wrap: break-word;
}
.content ul span {
  margin-right: 0.133333rem;
}
.content .name,
.phone {
  font-size: 0.426666rem;
}
.content .del {
  position: absolute;
  font-size: 0.48rem;
  right: 0.533333rem;
  top: 50%;
  -webkit-transform: translateX(-50%) translateY(-50%);
  -webkit-transform: translateX(-50%) translateY(-50%);
  -moz-transform: translateX(-50%) translateY(-50%);
  -ms-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);
}

.delivery-container .bottom {
  position: fixed;
  bottom: 0;
  padding: 0.213333rem 0.48rem;
  background-color: @white-color;
  left: 0;
  right: 0;
  height: 0.933333rem;
  box-shadow: 0 -0.06rem 0.1rem 0.04rem rgba(0, 0, 0, 0.03);
  display: flex;
  align-items: center;
}
</style>